import { withNavigationWatcher } from './contexts/navigation';
import { HomePage, ProfilePage, ETFPage } from './pages';

const routes = [
  {
    path: '/etf',
    component: ETFPage
  },
  {
    path: '/profile',
    component: ProfilePage
  },
  {
    path: '/home',
    component: HomePage
  }
];

export default routes.map(route => {
  return {
    ...route,
    component: withNavigationWatcher(route.component)
  };
});
